import { render } from "./AddClaimProviderComponent.vue?vue&type=template&id=3e03937e"
import script from "./AddClaimProviderComponent.vue?vue&type=script&lang=js"
export * from "./AddClaimProviderComponent.vue?vue&type=script&lang=js"

import "./AddClaimProviderComponent.vue?vue&type=style&index=0&id=3e03937e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__